import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRecurrence = (props) => /* @__PURE__ */ _jsxs("svg", {
	"data-testid": "recurrence-icon",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	height: "1em",
	width: "1em",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M13.9,15.315A5.61,5.61,0,0,0,18,17.564a5.25,5.25,0,0,0,0-10.5c-3.75,0-6,5.25-6,5.25s-2.25,5.25-6,5.25a5.25,5.25,0,0,1,0-10.5,6.615,6.615,0,0,1,4.5,2.383",
		fill: "none",
		stroke: "var(--icon-color, currentColor)",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5
	}), /* @__PURE__ */ _jsx("path", {
		d: "M9.884 5.748L10.5 9.447 6.801 10.064",
		fill: "none",
		stroke: "var(--icon-color, currentColor)",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5
	})]
});
export default SvgRecurrence;
